import React, { Component } from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';

import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
const { SearchBar } = Search;


import Select from 'react-select';


class DataOperate extends Component {
    constructor() {
        super();
        this.state = {
            data: null,
            headerLabel: {
                "fileColumn": "Column Name",
                "tableColumn": "Table Column",
            },
            defaultOptions: [
                { "label": "Select Option", "value": "default" },
                { "label": "Ignore Column", "value": "ignore" },
                { "label": "Add Column", "value": "add" }
            ],
            database_columns: []
        }

        this.handleChange = this.handleChange.bind(this);
        this.formatExtraColumns = this.formatExtraColumns.bind(this);
        this.flipJsonKeys = this.flipJsonKeys.bind(this);
        this.generateDbColumns = this.generateDbColumns.bind(this);
        this.getMapping = this.getMapping.bind(this);
        this.getRowStyle = this.getRowStyle.bind(this);
    }

    componentWillMount() {
        if (this.state.database_columns.length == 0) {
            var data = {};
            const db_columns = this.generateDbColumns();
            if (this.state.data == null) {
                let mapping = this.props.data.info.mapping_used;
                data.mapping = mapping;
                if (this.props.data.info.extra_columns.file !== null && this.props.data.info.extra_columns.file !== undefined && this.props.data.info.extra_columns.file.length !== 0){
                    let extra_file_columns = this.props.data.info.extra_columns.file;
                    for (let index = 0; index < extra_file_columns.length; index++) {
                        data.mapping[extra_file_columns[index]] = "default";
                    }
                }
            }
            this.setState({
                database_columns: db_columns,
                data:data
            })
        }  
    }

    componentDidUpdate(prevProps, nextState) {
        let currentDatabaseColumns = this.state.database_columns;
        if (currentDatabaseColumns.length !== this.props.data.info.database_columns.length) {
            currentDatabaseColumns = this.generateDbColumns();
            this.setState({
                database_columns: currentDatabaseColumns,
                data: null
            })
        }
    }

  
    componentDidMount() {
        feather.replace();   
    }

    getMapping() {
        const data = this.props.data.info
        var mappingKeys = Object.keys(data.mapping);
        var mapper = mappingKeys[mappingKeys.length - 1];
        return data.mapping[mapper];
    }

    handleChange(columnnKey,value, reference) {
        let data = this.state.data;
        const columnName = columnnKey;
        if (data == null) {
            let mapping = this.props.data.info.mapping_used;
            data = {};
            data.mapping = mapping;
        }

        if (data.mapping[columnName] == null || data.mapping[columnName] == undefined) {
            data.mapping[columnName] = value.value
        }
        else {
            data.mapping[columnName] = value.value
        }

        this.setState({
            data: data
        })
    }


    flipJsonKeys(obj) {
        let final_obj = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                final_obj[obj[key]] = key;
            }
        }
        return final_obj;
    }

    generateDbColumns() {
        const data = this.props.data.info
        // let mapping = this.getMapping();
        let mapping = data.mapping_used;
        let final_mapping = this.flipJsonKeys(mapping);
        let columnName_array = Object.keys(final_mapping);
        let dropdownArray = columnName_array.map((element, i) => {
            let innerArray = {};
            // innerArray['name'] = element;
            innerArray['label'] = element;
            if (data.database_columns.indexOf(element) !== -1) {
                innerArray['value'] = final_mapping[element];
            }
            return innerArray;
        });

        return dropdownArray;

    }

    formatExtraColumns() {
        const data = this.props.data.info
        let dropdownArray = [];
        if (data !== null) {
            dropdownArray = data.extra_columns.file.map((element, i) => {
                let innerArray = {};
                // innerArray['name'] = element;
                innerArray['label'] = element;
                innerArray['value'] = "unmapped";
                return innerArray;
            });
        }
        return dropdownArray;
    }

    getRowStyle = (row, rowIndex)=>{
        let style = {};
        if(row.actualValue == "unmapped"){
            style.backgroundColor = "#D3D3D3";
        }
        return style;
    }

    render() {

        const that = this;

        const extra_columns_array = this.formatExtraColumns();

        const currentDataState = [...extra_columns_array, ...this.state.database_columns];
        const optionArray = [...(this.state.defaultOptions.slice(0, 2)), ...this.state.database_columns];

        var infoBody = null;

        const columns = [
            {
                dataField: "label",
                text: "Column Name",
                sort: true,
                searchable: true

            },
            {
                dataField: "value",
                text: "Action",
            }
        ];

      
        var products = currentDataState.map((element,i)=>{
            let inner = {};
            let defaultValue = null;
            let options = [...optionArray];
            let addConfig = { "label": "Add Column", "value": "add" };


            inner['label'] = element.label;
            inner['actualValue'] = element.value;
            if(element.value !== "unmapped"){
                let index = i - extra_columns_array.length;
                defaultValue = that.state.database_columns[index];
            }
            else{
                defaultValue = options[0];
                options.splice(2, 0, addConfig);
            }

            inner['value'] = (
                    <Select
                        id={`columnConfig_${i}`}
                        className="col-md-12"
                        columnKey={element.label}
                        defaultValue={defaultValue}
                        isDisabled={false}
                        isLoading={false}
                        isSearchable={true}
                        name="columnDropdown"
                        options={options}
                        onChange={that.handleChange.bind('columnKey',element.label)}

                    />)
            return inner;
        });


        if (this.props.data.info.extra_columns.db.length !== 0) {
            let missingColumnList = this.props.data.info.extra_columns.db.join();
            let missingColumnMessage = `Missing Columns in file: ${missingColumnList}`;
            infoBody = (<div className="alert alert-warning mg-t-15" role="alert">
                <i className="mg-r-5" data-feather="info"></i>{missingColumnMessage}
            </div>);
        }

             

        return (
            <div className="animated fadeInRightBig">
                {infoBody}
                <ToolkitProvider
                    bootstrap4
                    keyField="mappingTable"
                    data={products}
                    columns={columns}
                    // rowStyle={this.getRowStyle}
                    search
                >
                    {
                        props => (
                            <div>
                                <SearchBar {...props.searchProps} />
                                <hr />
                                <BootstrapTable
                                    {...props.baseProps}
                                    rowStyle={this.getRowStyle}
                                />
                            </div>
                        )
                    }
                </ToolkitProvider>

        
            </div>
        )
    }
}

export default DataOperate;